import React from "react";

const S = {
  page: {
    fontFamily: "'DM Sans', sans-serif",
    background: "#FDF6EC",
    color: "#1A0A00",
    minHeight: "100vh",
    padding: "80px 6%",
    paddingTop: 100,
  },
  inner: {
    maxWidth: 720,
    margin: "0 auto",
  },
  h1: {
    fontSize: 32,
    fontWeight: 700,
    marginBottom: 8,
    color: "#1A0A00",
  },
  meta: {
    fontSize: 13,
    color: "#888",
    marginBottom: 40,
  },
  h2: {
    fontSize: 18,
    fontWeight: 600,
    marginTop: 36,
    marginBottom: 8,
    color: "#1A0A00",
  },
  p: {
    fontSize: 15,
    lineHeight: 1.75,
    color: "#4a3f32",
    marginBottom: 12,
  },
  a: { color: "#E8470A", textDecoration: "none" },
};

export default function TermsPage() {
  return (
    <div style={S.page}>
      <div style={S.inner}>
        <h1 style={S.h1}>Terms of Use</h1>
        <p style={S.meta}>Last updated: April 2026 · The Works Company</p>

        <h2 style={S.h2}>For Store Owners</h2>

        <h2 style={S.h2}>Free Period and Pricing</h2>
        <p style={S.p}>KiranaOS is completely free to use until 31 December 2026. After this date, store owners who wish to continue using KiranaOS pay one simple plan of ₹35 per month, with no commission, no order caps, and no hidden charges. We will give you clear advance notice on WhatsApp before any charge begins. KiranaOS does not currently store card details or collect subscription payments, and you will never be charged without prior notice and your consent.</p>

        <h2 style={S.h2}>Your Store, Your Responsibility</h2>
        <p style={S.p}>You are responsible for the accuracy of the products, prices, and information listed on your KiranaOS storefront. KiranaOS is a technology platform — we are not responsible for order fulfilment, delivery, or disputes between you and your customers. Ensure your store complies with all applicable Indian laws, including consumer protection and food safety regulations.</p>

        <h2 style={S.h2}>Cancellation</h2>
        <p style={S.p}>You may cancel your account at any time with no penalty. On cancellation, your data is retained for 90 days before deletion.</p>

        <h2 style={S.h2}>Prohibited Use</h2>
        <p style={S.p}>You may not use KiranaOS to list illegal products, misrepresent goods or pricing, mislead customers, or engage in any activity that violates applicable Indian law. We reserve the right to suspend or terminate accounts that violate these terms without prior notice.</p>

        <h2 style={S.h2}>For Customers</h2>

        <h2 style={S.h2}>Platform Role</h2>
        <p style={S.p}>KiranaOS is a technology platform that connects customers with local kirana stores. Orders are placed with and fulfilled by the store owner directly. KiranaOS is not responsible for product quality, availability, delivery, or disputes arising from any order.</p>

        <h2 style={S.h2}>Your Phone Number</h2>
        <p style={S.p}>Your phone number is collected solely to verify your identity via OTP and to send order updates via WhatsApp. It will not be shared with any third party other than the store you are ordering from.</p>

        <h2 style={S.h2}>Refunds and Cancellations</h2>
        <p style={S.p}>Refund and cancellation policies are set by each store owner. Please contact your store owner directly for any order issues. KiranaOS does not process refunds.</p>

        <h2 style={S.h2}>Governing Law</h2>
        <p style={S.p}>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Ghaziabad, Uttar Pradesh.</p>

        <h2 style={S.h2}>Changes to Terms</h2>
        <p style={S.p}>We may update these terms occasionally. We will notify store owners via WhatsApp if material changes are made. Continued use of KiranaOS after such notice constitutes acceptance of the updated terms.</p>

        <h2 style={S.h2}>Contact</h2>
        <p style={S.p}>The Works Company<br />Email: <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a></p>

        <h2 style={S.h2}>Company Information</h2>
        <p style={S.p}>
          KiranaOS is a product of The Works Company, a proprietorship registered in India.
          <br />GSTIN: 09AGVPN5611M2ZM
          <br />Udyam Registration No.: UDYAM-UP-29-0233769 (MSME)
          <br />Contact: <a href="mailto:hello@kiranaos.in" style={S.a}>hello@kiranaos.in</a> · +91 88603 10303
        </p>
        <p style={S.p}>
          You can independently verify our MSME registration at{" "}
          <a href="https://udyamregistration.gov.in" target="_blank" rel="noopener noreferrer" style={S.a}>udyamregistration.gov.in</a>{" "}
          and our GSTIN at{" "}
          <a href="https://www.gst.gov.in" target="_blank" rel="noopener noreferrer" style={S.a}>gst.gov.in</a>.
        </p>
      </div>
    </div>
  );
}
